<template>
  <v-dialog v-model="open" max-width="800px" persistent class="contract-history-modal">
    <v-card class="contract-history-modal__card">
      <v-toolbar color="primary" flat class="contract-history-modal__toolbar">
        <v-toolbar-title class="contract-history-modal__title white--text">
          Histórico de Contratos
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon color="white" @click="close" class="contract-history-modal__close-btn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="contract-history-modal__content pa-6">
        <div v-if="contract && contract.historic && contract.historic.length > 0">
          <v-timeline dense>
            <v-timeline-item
              v-for="(item, index) in contract.historic"
              :key="index"
              small
              :color="getTimelineColor(index)">
        
              <v-card class="elevation-1">
                <v-card-title class="text-subtitle-1">
                  {{ item.name }}
                </v-card-title>
                <v-card-text>
                  <div class="text-caption mb-2">
                    <div>Substituído em: {{ formatDate(item.archivedAt) }}</div>
                    <div>Inserido em: {{ formatDate(item.createdAt) }}</div>
                  </div>
                  <div class="d-flex align-center">
                    <v-btn
                      small
                      color="primary"
                      class="mr-2"
                      @click="downloadHistoricFile(item)"
                      :loading="downloadingFileId === item.id_doc"
                    >
                      <v-icon left small>mdi-download</v-icon>
                      Baixar
                    </v-btn>
                  </div>
                </v-card-text>
              </v-card>
            </v-timeline-item>
          </v-timeline>
        </div>
        <div v-else class="text-center pa-4">
          <v-icon large color="grey lighten-1">mdi-history</v-icon>
          <p class="text-subtitle-1 grey--text mt-2">Nenhum histórico disponível para este contrato.</p>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogDownload" max-width="400">
                  <v-card class="download-dialog">
                  <v-card-title class="headline d-flex align-center">
                    <v-icon color="primary" class="mr-2">mdi-download</v-icon>
                    Salvar Arquivo
                  </v-card-title>
                  <v-card-text class="pt-4">
                    <p class="text-body-1">
                      O arquivo está pronto para ser baixado. Clique no botão abaixo para salvá-lo em seu computador.
                    </p>
                    <v-alert
                      type="info"
                      variant="tonal"
                      class="mt-3"
                      icon="mdi-information"
                    >
                      Após o download, esta janela fechará automaticamente.
                    </v-alert>
                  </v-card-text>
                  <v-card-actions class="pa-4">
                    <v-spacer></v-spacer>
                    <a :href="fileLink" download class="text-decoration-none">
                      <v-btn
                        color="primary"
                        variant="elevated"
                        prepend-icon="mdi-download"
                        @click="dialogDownload = false"
                      >
                        Salvar Arquivo
                      </v-btn>
                    </a>
                    <v-btn
                      color="white"
                      variant="text"
                      class="ml-2"
                      @click="dialogDownload = false"
                    >
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
  </v-dialog>
</template>

<script>
import ContractRequestStorage from "@/services/storage/ContractRequestStorage";
import { showErrorSnackBar } from "@/utils/SnackBartHelper";

export default {
  name: "ContractHistoryModal",
  props: {
    open: {
      type: Boolean,
      default: false
    },
    contract: {
      type: Object,
      default: () => ({})
    },
    close: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    dialogDownload: false,
    fileLink: null,
    downloadingFileId: null
  }),
  methods: {
    formatDate(timestamp) {
      if (!timestamp) return 'Data não disponível';
      
      try {
        const date = new Date(timestamp);
        if (isNaN(date)) {
          console.error('Invalid date:', timestamp);
          return 'Data inválida';
        }
        
        return date.toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit'
        });
      } catch (error) {
        console.error('Error formatting date:', error);
        return 'Erro ao formatar data';
      }
    },
    formatFileSize(size) {
      if (!size) return 'Tamanho não disponível';

      const units = ['B', 'KB', 'MB', 'GB'];
      const unitIndex = Math.floor(Math.log(size) / Math.log(1024));

      const value = size / Math.pow(1024, unitIndex);

      return `${value.toFixed(1)} ${units[unitIndex]}`;
    },
    getTimelineColor(index) {
      const colors = ['primary', 'secondary', 'success', 'info', 'warning'];
      return colors[index % colors.length];
    },
    async downloadHistoricFile(item) {
      if (!item || !item.path) {
        showErrorSnackBar("Arquivo não disponível para download");
        return;
      }
      
      try {
        this.downloadingFileId = item.id_doc;
        const fileBlob = await ContractRequestStorage.downloadImg(item.path);
        this.fileLink = URL.createObjectURL(fileBlob);
        this.dialogDownload = true;
      } catch (error) {
        console.error("Erro ao baixar arquivo:", error);
        showErrorSnackBar("Erro ao baixar arquivo. Tente novamente.");
      } finally {
        this.downloadingFileId = null;
      }
    }
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>
.contract-history-modal {
  &__card {
    border-radius: 8px;
    overflow: hidden;
  }

  &__toolbar {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  &__close-btn {
    margin-right: -12px;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 500;
  }

  &__content {
    background-color: #FFF;
    max-height: 70vh;
    overflow-y: auto;
  }
}
</style> 